import Vue from 'vue';
import Router from 'vue-router';
import AddRouter from '@/vuepage/AddRouter';

import AuthorityManage from './modules/authority-manage';
import CategoryManage from './modules/category-manage';
import FileManage from './modules/file-manage';

// const Login = () => import('@/vuepage/Login');
const WxLogin = () => import('@/vuepage/WxLogin');
const Index = () => import('@/vuepage/Index');
const PreviewExcel = () => import('@/vuepage/file-manage/PreviewExcel');

Vue.use(Router);

const children = [
  ...AuthorityManage,
  ...CategoryManage,
  ...FileManage
];

const router = new Router({
  routes: [
    {
      path: '',
      redirect: '/login'
    },
    {
      path: '/login',
      component: WxLogin
    },
    {
      path: '/preview-excel',
      name: 'preview-excel',
      component: PreviewExcel
    },
    {
      path: '/index',
      component: Index,
      children
    },
    {
      path: '/addrouter',
      component: AddRouter
    }
  ],
  mode: 'history'
});

export default router;